import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

import AppLoader from '@/components/AppLoader.vue';
import config from '@/utils/config';
import App from './App.vue';
import router from './router';
import store from './store';
import http from './api';
import vuetify from './plugins/vuetify';
import parseDate from './filters/parse-date';

import '@/assets/styles/index.scss';

Vue.component('app-loader', AppLoader);
Vue.filter('parseDate', parseDate);

Vue.prototype.$http = http;
Vue.config.productionTip = false;

if (config.SENTRY_DSN) {
  Sentry.init({
    Vue,
    dsn: config.SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    logErrors: true,
  });
}

const app = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');

export default app;
